export const TOP_BAR_PERCENT = 15;
export const WHITE_TEXT = '#E8E8E8';
